import React from 'react'

import { Box, JustifyContent, Display } from '@gousto-internal/citrus-react'

import { withError } from 'utils/withError'

import { BoxPriceBlock } from '../BoxPriceBlock'
import { BoxPricesListProps } from './boxPricesListModels'

const BoxPricesList = ({ numPersonsToBoxDescriptors, selectedBox }: BoxPricesListProps) => (
  <Box
    display={Display.Flex}
    justifyContent={JustifyContent.Center}
    gap={8}
    key={selectedBox}
    data-testid="boxPricesList"
  >
    {Object.entries(numPersonsToBoxDescriptors).map(([numPersonsStr, boxDescriptors]) => {
      const key = `box-type-${numPersonsStr}`
      const numPersons = parseInt(numPersonsStr, 10)

      return (
        <>
          <BoxPriceBlock
            key={key}
            numPersons={numPersons}
            boxInfo={boxDescriptors}
            isSelected={selectedBox === numPersons}
          />
        </>
      )
    })}
  </Box>
)

export const BoxPricesListContainer = withError(BoxPricesList)
